module.exports = __webpack_public_path__ + "img/association-road-2.6ea5c242.png";